import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Buttons, Spacer, boxContainer, questionnaireComponents } from "..";

import "./styles.css";
import { UtilityArrays } from "../../config";

const Others = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [state, setState] = useState({
    otherImportantFactors: "",
    supportNeeded: [],
    halalFoodImportance: "",
  });

  useEffect(() => {
    setState({
      otherImportantFactors: questionnaire?.otherImportantFactors ?? "",
      supportNeeded: questionnaire?.supportNeeded ?? [],
      halalFoodImportance: questionnaire?.halalFoodImportance ?? "",
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <questionnaireComponents.QuestionnaireLabel
        text="1. What other important factors would you consider while choosing a
          university?"
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireValueBox
        value={state?.otherImportantFactors}
        style={{ marginLeft: "0.75em" }}
      />
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel text="2. What support do you need for applying to university?" />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireMultipleSelect
        style={{ marginLeft: "0.75em" }}
        value={state?.supportNeeded}
        array={UtilityArrays.supportArray}
      />
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="3. How important are halal food options for you?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.halalFoodImportance}
      />
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Profile Builder")}
          >
            Done
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Others;
